import { EntityActions, LocationActions } from '../actions/consts';

type LocationsUIState = {
  loading: boolean;
  errorMessage: string;
  currentList: [];
  currentPage: number,
}

type LocationsState = {
  entities: {};
  ui: LocationsUIState;
}

export function locations(
  state = { entities: {}, ui: { currentList: [], currentPage: 0, loading: false, errorMessage: '' } } as LocationsState, action
) {
  switch (action.type) {
    case EntityActions.ADD_ENTITIES:
      return {
        ...state,
        entities: {
          ...state.entities,
          ...action.entities.locations,
        }
      };
    case LocationActions.LOAD_REQUEST:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: true,
          errorMessage: '',
        }
      };
    case LocationActions.LOAD_SUCCESS:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: '',
        }
      };
    case LocationActions.LOAD_ERROR:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: action.error.errorMessage,
        }
      };
    case LocationActions.LOAD_LIST_SUCCESS:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: '',
          currentList: action.result,
        }
      };
    case LocationActions.SET_CURRENT_PAGE:
      return {
        ...state,
        ui: {
          ...state.ui,
          currentPage: action.currentPage,
        }
      };
    default:
      return state;
  }
}
